<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="control-block-left">
                <div class="flex">
                    <p class="btn-back caption-help margin-right-10">
                        <router-link :to="$route.query.returnUrl ? $route.query.returnUrl : '/projects/' + $route.params.projectId">Проект</router-link>
                    </p>
                    <p class="caption-help margin-right-10">
                        Пользователи
                    </p>
                </div>
            </div>
            <div class="control-block-right">
                <div class="btns flex">
                    <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                           class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange()" />
                    <input type="file" id="dropFiles2" ref="dropFiles2" name="dropFiles2"
                           class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange2()" />
                    <button class="btn" @click="onExportReport()">
                        Отчет
                    </button>
                    <button type="button" class="btn" onclick="document.getElementById('dropFiles2').click()">
                        Массовый Импорт
                    </button>
                    <button type="button" class="btn" onclick="document.getElementById('dropFiles').click()">
                        Импорт
                    </button>
                    <button class="btn" @click="onExport()">
                        Экспорт
                    </button>
                    <button id="sample_editable_1_2_new" class="btn" @click="onNewEntity()">
                        Новый пользователь
                    </button>
                </div>
            </div>
            <div class="body-panel-control-separator">

                <complex-filter ref="complexFilter" v-if="infoLoaded"
                                :cacheKey="'usersComplexFilter'"
                                :filters="userFilters"
                                :searchFunction="searchFunction"
                                :tableName="'[dbo].[AspNetUsers]'"
                                @onFilterChange="onFilterChange"
                                :withTableNameInClause="true"></complex-filter>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page">
            <div v-if="importResult != null" class="margin-bottom-10">
                Успешно импортировано: {{ importResult.SuccessfullyExported }} строк<br><br>
                <template v-if="importResult.Errors.length">
                    Ошибки:<br>
                    <ul>
                        <li v-for="error of importResult.Errors">
                            {{error}}
                        </li>
                    </ul>
                </template>
                <button class="btn" @click="importResult = null;">Закрыть</button>
            </div>
            <table class="table-view" id="dataTable">
                <thead>
                <tr class="heading">
                    <th>#</th>
                    <th>Фамилия</th>
                    <th>Имя</th>
                    <!--<th>Отчество</th>-->
                    <th>Роль</th>
                    <th>Телефон</th>
                    <!--<th>Email</th>-->
                    <th>Согласия</th>
                    <th>Статус документов</th>
                    <th>Активность</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) of users"
                    @click.stop="onItemClick($event, item)"
                    :class="[
                            {'check-need': item.PassportVerificationState === 1},
                            {'check-fail': item.PassportVerificationState === 3},
                            {'approve-need': item.RegisteredManually && item.RegisterStatus === 1}
                         ]">
                    <td class="id">{{ i+1 }}</td>
                    <td>{{ item.LastName }}</td>
                    <td>{{ item.FirstName }}</td>
                    <!--<td>{{ item.MiddleName }}</td>-->
                    <td>{{ getCurrentRoleName(item) }}</td>
                    <td class="phone">{{ item.PhoneNumber }}</td>
                    <!--<td class="email">{{ item.Email }}</td>-->
                    <td class="left-140">
                        {{ formatAcception(item) }}
                    </td>
                    <td class="left-140">
                        {{ formatPassportVerificationState(item.PassportVerificationState) }}
                    </td>
                    <td class="left-140">
                        {{ formatUserStatus(item) }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <vue-headful title="Пользователи" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import 'datatables.net'
    import BackendApi from '../backendApi'
    import UI from '../helpers/ui-helpers'
    import moment from 'moment'
    import config from '../config'
    import projectMixin from '../helpers/project-mixin'

    let backendApi = new BackendApi();
    let cacheKey = 'usersState';

    const rowsPerPage = 30;

    let processFilter = function(filter){
      if(!filter){
        return null;
      }
        let filterCopy = JSON.parse(JSON.stringify(filter));
        let stateEnums = {
            '[dbo].[AspNetUsers].[TermsConfirmed]': {
                'Да': 1,
                'Нет': 0
            },
            '[dbo].[AspNetUsers].[PersonalDataEditingAccept]': {
                'Да': 1,
                'Нет': 0
            },
            '[dbo].[AspNetUsers].[NotificationsEnabled]': {
                'Да': 1,
                'Нет': 0
            },
            '[dbo].[AspNetUsers].[PassportVerificationState]': {
                'паспортные данные отсутствуют': 0,
                'проверь паспортные данные!': 1,
                'паспортные данные подтверждены': 2,
                'паспортные данные возвращены': 3
            },
            '[dbo].[AspNetUsers].[RegisterStatus]': {
                'неактивен': 0,
                'проверка': 1,
                'активен': 2,
                'отказано': 3,
                'отключен': 4,
                'заблокирован': 5
            },
          '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]': {
            'банковская карта отсутствует': 0,
            'проверь банковскую карту!': 1,
            'банковская карта подтверждена': 2,
            'банковская карта возвращена': 3
          }
        };

        let resultFilter = [];
        for (let item of filterCopy) {
            let filterField = item[0];
            //console.info('item:', JSON.stringify(item))
            let dontPushItem = false;
            if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]'
                ||filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]'
                || filterField === '[dbo].[AspNetUsers].[RegisterStatus]' || filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]') {

                let values = item[2].substring(1, item[2].length - 1).split(';').map(x => decodeURI(x)).map(x => {
                    let name = x.substring(1, x.length - 1);
                    let state = stateEnums[filterField][name];
                    return state;
                });

                if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]'
                    || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]'
                    || filterField === '[dbo].[AspNetUsers].[RegisterStatus]' || filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]') {

                    item[0] = `isnull(${filterField}%comma%0)`;

                    if(filterField === '[dbo].[AspNetUsers].[RegisterStatus]'){
                        let dateFilters = values.filter(x => x === 4 || x === 5 || x === 2);
                        let statusFilters = values.filter(x => x !== 4 && x !== 5 && x !== 2);

                        let dateFilterPart = '';
                        if(dateFilters.length) {
                            if (values.indexOf(4) > -1 && values.indexOf(5) === -1) {
                                // только Отключен
                                dateFilterPart = '[dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())';
                            }
                            if (values.indexOf(5) > -1 && values.indexOf(4) === -1) {
                                // только Заблокирован
                                dateFilterPart = '[dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate()';
                            }
                            if (values.indexOf(5) > -1 && values.indexOf(4) > -1) {
                                // оба фильтра
                                dateFilterPart = '([dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() or [dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate())';
                            }

                            // если есть фильтр "Активен"
                            if(values.indexOf(2) > -1 ){
                                if(dateFilterPart){
                                    // если уже указаны фильтры Заблокирован или Отключен
                                    dateFilterPart = '( (' + dateFilterPart + ') or [dbo].[AspNetUsers].[RegisterStatus] = 2' + ')';
                                }else{
                                    // только фильтр Активен
                                    dateFilterPart = '[dbo].[AspNetUsers].[RegisterStatus] = 2 and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())' +
                                        'and ([dbo].[UserDynamicRoles].[DisabledDateTime] is null or [dbo].[UserDynamicRoles].[DisabledDateTime] > getdate())';
                                }
                            }
                        }

                        if(statusFilters.length){
                            item[2] = '(' + values.filter(x => x !== 4 && x !== 5 && x !== 2).map(function (item) {
                                return `${encodeURI(item)}`;
                            }).join(';') + ')';
                        }
                        else{
                            dontPushItem = true;
                        }

                        if(dateFilters.length && !statusFilters.length){
                            resultFilter.push(['','', dateFilterPart]);
                        }

                        if(dateFilters.length && statusFilters.length){
                            dontPushItem = true;
                            resultFilter.push(['','', '(' + item.join(' ') + ' or ' + dateFilterPart + ')']);
                        }

                    }
                    else if(filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]'){
                        let hasNullStatus = values.indexOf(0) > -1;
                        let statuses = values.filter(x => x !== 0);

                      if(hasNullStatus && statuses.length){
                        resultFilter.push(['','', '([dbo].[UserPaymentSettings].[VerificationStateId] in (' + statuses.join('%comma% ') +
                        ') or [dbo].[UserPaymentSettings].[VerificationStateId] is null)']);
                        dontPushItem=true;
                      }
                      else if(hasNullStatus){
                        item[1]='is';
                        item[2] = 'null';
                      }else{
                        item[2] = '(' + statuses.map(function (i) {
                          return `${encodeURI(i)}`;
                        }).join(';') + ')';
                      }
                    }
                    else{
                        item[2] = '(' + values.map(function (item) {
                            return `${encodeURI(item)}`;
                        }).join(';') + ')';
                    }

                }
                else {
                    item[2] = '(' + values.map(function (item) {
                        return `'${encodeURI(item)}'`;
                    }).join(';') + ')';
                }
            }

            if(filterField === '[dbo].[AspNetUsers].[UserRole]'){
              item[0] = '[dbo].[DynamicRole]';
            }

            if(filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]'){
                item[0] = '[dbo].[UserPaymentSettings].[VerificationStateId]';
            }

            if(!dontPushItem) {
                resultFilter.push(item);
            }
        }

        return resultFilter;
    };

    export default {
        name: "users",

        data() {
            return {
                page: 1,
                users: [],
                importResult: null,
                loading: false,
                canBeLoaded: true,
                filter: null,
                userFilters: [
                    {
                        Value: 'LastName', Name: 'Фамилия'
                    },
                    {
                        Value: 'FirstName', Name: 'Имя'
                    },
                    {
                        Value: 'PhoneNumber', Name: 'Телефон'
                    },
                    {
                        Value: 'Email', Name: 'Email'
                    },
                    {
                        Value: 'TermsConfirmed', Name: 'Согласен на условия'
                    },
                    {
                        Value: 'PersonalDataEditingAccept', Name: 'Согласен на обработку'
                    },
                    {
                        Value: 'NotificationsEnabled', Name: 'Согласен на рассылку'
                    },
                    {
                        Value: 'PassportVerificationState', Name: 'Статус документов'
                    },
                    {
                        Value: 'RegisterStatus', Name: 'Активность'
                    },
                    {
                        Value: 'UserRole', Name: 'Роль'
                    },
                  /*{
                    Value: 'PaymentSettingsVerificationState', Name: 'Банковская карта'
                  }*/
                ],
                roles:[],
                scrollTop: null,
                firstLoad: true,
                project: null,
                infoLoaded: false
            }
        },

        mixins: [projectMixin],

        methods: {
            onNewEntity() {
                this.$router.push('/projects/' + this.$route.params.projectId + '/users/0');
            },

            getCurrentRoleName(item){
                let projectId = this.$route.params.projectId;
                if(item.UserDynamicRoles.length){
                    return item.UserDynamicRoles.find(x => x.ProjectId == projectId).RoleName;
                }
                return '';
            },

            onFileChange(){
                let vm = this;

                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        let projectId = this.$route.params.projectId;
                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/user/import?projectId=' + projectId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка импорта');
                                }
                                else {
                                    vm.importResult = resp.result;
                                    UI.toastr.success('Успешно импортировано');
                                    vm.page = 1;
                                    vm.users = [];
                                    vm.loadNext();
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error('Ошибка на сервере');
                                console.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

          onFileChange2(){
                let vm = this;

                let files = document.getElementById('dropFiles2').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        let projectId = this.$route.params.projectId;
                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/user/import-users?projectId=' + projectId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка импорта');
                                }
                                else {
                                    vm.importResult = resp.result;
                                    UI.toastr.success('Успешно импортировано');
                                    vm.page = 1;
                                    vm.users = [];
                                    vm.loadNext();
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error('Ошибка на сервере');
                                console.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            loadRoles() {
                let vm = this;
                return this.callApiWrapper(backendApi.rolesList(vm.$route.params.projectId))
                    .then(function (resp) {
                        if (resp.data) {

                            for(let r = 0; r < resp.data.Roles.length; r++) {
                                if (!resp.data.Roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                    vm.roles.push({
                                        Id: resp.data.Roles[r].Id,
                                        Name: resp.data.Roles[r].Name
                                    });
                                }
                            }
                        }
                    });
            },

            loadNext(){
                let vm = this;

                let projectId = this.$route.params.projectId;
                this.loading = true;

                let skip = (vm.page - 1) * rowsPerPage;
                let take = rowsPerPage;
                if (vm.firstLoad && vm.page > 1) {
                    skip = 0;
                    take = vm.page * rowsPerPage;
                }

                UI.blockUI('.dataContent', 'Загрузка...');
                console.info('processFilter(vm.filter):', processFilter(vm.filter));

                this.callApiWrapper(backendApi.usersList(skip, take, projectId, processFilter(vm.filter)))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрзуки пользователей');
                        }
                        else{
                            if(resp.data && resp.data.length) {

                                vm.users.push(...resp.data);

                                if (vm.firstLoad) {
                                    vm.firstLoad = false;
                                    if (vm.scrollTop) {
                                        $('.body-panel-content').animate({scrollTop: vm.scrollTop}, 500);
                                    }
                                }
                            }
                            else{
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
            },

          loadProject(){
            let vm = this;

            return this.callApiWrapper(backendApi.projectLoad(vm.$route.params.projectId)).then(function (resp) {
              if (resp.data) {
                vm.project = resp.data;
              }
            });
          },

            onItemClick($event, item) {
                let vm = this;
                vm.saveFilterState();

                if($event.ctrlKey === true){
                    window.open('/projects/' + this.$route.params.projectId + '/users/' + encodeURIComponent(item.UserName));
                }
                else{
                    vm.$router.push('/projects/' + vm.$route.params.projectId + '/users/' + encodeURIComponent(item.UserName));
                }

            },

            formatAcception(user){
                let info = '';
                if(user.TermsConfirmed){
                    info = 'на условия';
                }
                if (user.PersonalDataEditingAccept) {
                    if (info) {
                        info += '; ';
                    }
                    info += 'на обработку';
                }
                if(user.NotificationsEnabled){
                    if (info){
                        info += '; ';
                    }
                    info += 'на рассылку';
                }

                return info;
            },

            formatPassportVerificationState(stateId){
                switch (stateId)
                {
                    case 1:
                        return 'проверь документы!';
                    case 2:
                        return 'подтверждены';
                    case 3:
                        return 'возвращены';
                    default:
                        return 'отсутствуют';
                }
            },

          /*formatPaymentSettingsVerificationState(stateId){
            switch (stateId)
            {
              case 1:
                return 'проверь банковскую карту!';
              case 2:
                return 'банковская карта подтверждена';
              case 3:
                return 'банковская карта возвращена';
              default:
                return 'банковская карта отсутствует';
            }
          },*/

            formatUserStatus(item){
                if(item.IsBlocked){
                    return 'Заблокирован';
                }
                if(item.IsDisabled){
                    return 'Отключен';
                }
                return item.RegisterStatusFormatted;
            },

            onExport() {
                let projectId = this.$route.params.projectId;
                let vm = this;
                let filterstr = [];

                if (vm.filter) {
                    let processedFilter = processFilter(vm.filter);
                    for (let i = 0; i < this.filter.length; i++) {
                        let item = processedFilter[i];
                        filterstr.push(JSON.stringify(item));
                    }
                }

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.userExport(projectId, filterstr, '', '', '', '', '', ''))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Пользователи.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onExportReport() {
                let projectId = this.$route.params.projectId;

                let vm = this;
                let filterstr = [];
                if (vm.filter) {
                    let processedFilter = processFilter(vm.filter);
                    for (let i = 0; i < this.filter.length; i++) {
                        let item = processedFilter[i];
                        filterstr.push(JSON.stringify(item));
                    }
                }
                let nowDate = moment(new Date()).format('DD.MM.YYYY');

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.userExportReport(projectId, filterstr))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Отчет по пользователям ' + nowDate + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }

                        UI.unblockUI('#app');
                    });
            },

            getFilterForUri(){
                let str = '';
                if(this.filter) {
                    let processedFilter = processFilter(this.filter);
                    for (let i = 0; i < processedFilter.length; i++) {
                        let item = processedFilter[i];
                        str += `&filter[${i}]=${JSON.stringify(item)}`;
                    }
                }
                return str;
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback){
                console.info('columnName:', columnName);
                if(columnName === 'TermsConfirmed' || columnName === 'PersonalDataEditingAccept' || columnName === 'NotificationsEnabled')
                {
                    callback(['Да', 'Нет']);
                }
                else if(columnName === 'PassportVerificationState'){
                    callback(['паспортные данные отсутствуют', 'проверь паспортные данные!', 'паспортные данные подтверждены', 'паспортные данные возвращены']);
                }
                else if(columnName === 'RegisterStatus'){
                    callback(['неактивен', 'проверка', 'активен', 'отказано', 'отключен', 'заблокирован']);
                }
                else if (columnName === 'PaymentSettingsVerificationState'){
                    callback(['банковская карта отсутствует', 'проверь банковскую карту!',
                      'банковская карта подтверждена', 'банковская карта возвращена']);
                }
                else {
                    let filterFormatted = '';
                    if(filters){
                        filterFormatted = processFilter(filters).map(x => {return JSON.stringify(x)});
                    }

                    this.callApiWrapper(backendApi.userDistinctValues(columnName, this.$route.params.projectId, search, filterFormatted,
                        (searchPage - 1) * 30, 30))
                        .then(function (resp) {
                            callback(resp.data);
                        })
                }
            },

            onFilterChange(filter) {
                // спец. настройка для статусов
                // пока так, поскольку динамический фильтр не поддерживает enums
                this.filter = filter;
                this.users = [];
                this.loading = false;
                this.canBeLoaded = true;
                this.page = 1;

                this.loadNext();
            },

            saveFilterState() {
                let stateObj = {
                    projectId: this.projectId,
                    page: this.page,
                    scrollTop: this.scrollTop,
                    filter: this.filter
                };
                sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
                console.info('recoverFilterState', stateObj);
                if (stateObj) {
                    if (stateObj.projectId == this.projectId) {
                        if (stateObj.page) {
                            this.page = stateObj.page;
                        }
                        if (stateObj.scrollTop) {
                            this.scrollTop = stateObj.scrollTop;
                        }
                        // if (stateObj.filter) {
                        //     this.filter = stateObj.filter;
                        // }
                    }
                    this.clearFilterState();
                }
            },

            clearFilterState() {
                sessionStorage.removeItem(cacheKey);
            }
        },

        mounted() {
            let vm = this;

            vm.recoverFilterState();

            Promise.all([vm.loadRoles(), vm.loadProject()]).then(function(){
                //console.info('loaded!')
                if(vm.project.ProjectHasPhysicalBankCardReward){
                  vm.userFilters.push({
                    Value: 'PaymentSettingsVerificationState', Name: 'Банковская карта'
                  });
                }
                vm.infoLoaded = true;

                  vm.$nextTick(() => {

                    $('.body-panel-content').on('scroll', function () {
                      let elem = $(this);
                      vm.scrollTop = elem.scrollTop();

                      if(!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                        if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                          vm.page++;
                          vm.loadNext();
                        }
                      }
                    });

                    vm.filter = vm.$refs.complexFilter.getExpotData();

                    vm.loadNext();
                  })

            });


        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>

<style scoped>
    .table-view thead {display: table-row-group;}
</style>



// WEBPACK FOOTER //
// Content/src/views/Users.vue